import {FC, ReactNode, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Header from './header';
import css from './index.module.scss';

import { isMiaotouApp } from '@/utils/toolsNew';

type LayoutProps = {
  children: ReactNode;
};

const  Layout: FC<LayoutProps> = ({ children }) => {
  
  // 可以通过不同的 router.pathname 判断加载不同的header 和 footer 也可以把layout 写成hoc
  const router = useRouter();

  const [isApp, setIsApp] = useState(false); // 判断是否在app

  useEffect(() => {
    if (isMiaotouApp(navigator.userAgent)) setIsApp(true);
  }, [])

  if (
    router.pathname.startsWith('/vip') ||
    router.pathname.startsWith('/gift_card') ||
    router.pathname.startsWith('/App') ||
    router.pathname.startsWith('/industryStrategy') ||
    router.pathname.startsWith('/report') ||
    router.pathname.startsWith('/rule/ai_policy') ||
    router.pathname.startsWith('/live') ||
    router.pathname.startsWith('/order') ||
    router.pathname.startsWith('/share') ||
    isApp // 如果在app 不展示m站header
  ) {
    return <>{children}</>;
  }

  return (
    <>
      <Header></Header>
      <main className={css.container}>{children}</main>
    </>
  );
}

export default Layout;
